import React from "react";
import { Image } from "semantic-ui-react";
import nationwideImage from "../../assets/images/nationwide-coverage.png";
import worldwideImage from "../../assets/images/worldwide-coverage.jpg";

export const getNationwide = (type) => {
  if (type === "world") {
    return <Image wrapped size="medium" src={worldwideImage} centered />;
  }
  return (
    <div>
      <Image inline size="medium" src={nationwideImage} centered />

      <p className={"text-center"}>
        We are pleased to provide nationwide* coverage of this search
      </p>
      <p className={"text-center"}>
        * Includes Puerto Rico &amp; Virgin Islands
      </p>
    </div>
  );
};

export default getNationwide;



// WEBPACK FOOTER //
// ./src/components/coveragearea/Nationwide.js